import { render } from "./PagoResultSection.vue?vue&type=template&id=4a50c6ef&ts=true"
import script from "./PagoResultSection.vue?vue&type=script&lang=ts"
export * from "./PagoResultSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__